// -1 is the entrance. Finishing a collection never starts an automatic timer.
// A fresh forward gesture returns to the entrance; another enters exhibit one.
export function tourTarget(current, direction, count) {
  if (!Number.isInteger(count) || count < 1 || ![-1, 1].includes(direction)) return current;
  if (current < 0) return direction > 0 ? 0 : -1;
  if (current >= count - 1 && direction > 0) return -1;
  return Math.min(count - 1, Math.max(0, current + direction));
}
export function isReturnTrip(from, to, count) {
  return count > 0 && from === count - 1 && to === -1;
}
